<ng-container *ngIf="hasLoaded|async; else loadingProfile">

  <div class="user-header" [class.small-user-header]="_small">
    <div class="user-avatar-wrapper">
      <div class="user-avatar" [class.small-user-avatar]="_small">
        <img *ngIf="currentUserProfilePicture" [@fadeInOut] [src]="currentUserProfilePicture|safe:'url'"
             alt="User Profile Picture">
      </div>
    </div>

    <div class="user-info-wrapper" [class.small-info-wrapper]="_small">
      <h1 class="user-full-name">{{currentUser.displayName}} - <span
        class="employee-id">{{currentUser.employeeId}}</span></h1>
      <h2 class="user-job-title">{{currentUser.jobTitle}} {{_small ? ' - ' + currentUser.department : ''}}</h2>
      <h2 class="user-job-department" *ngIf="!_small">{{currentUser.department}}</h2>
      <ng-container *ngIf="!_small">
        <span class="user-crt-status">Last login: {{currentUser.loginDatetime | date:'shortDate'}}
          at {{currentUser.loginDatetime | date:'shortTime'}}</span>
        <span class="user-crt-status" *ngIf="currentUser.isCRT && !isSessionUser">This user is a member of the Component Reliability team.</span>
        <span class="user-crt-status" *ngIf="currentUser.isCRT && isSessionUser">You are a member of the Component Reliability team.</span>
      </ng-container>
    </div>

    <div class="user-actions-wrapper" [class.small-user-actions-wrapper]="_small">
      <a class="contact-button" [href]="contactLinkAddress" mat-stroked-button *ngIf="!isSessionUser">Contact</a>
    </div>
  </div>
</ng-container>
<ng-template #loadingProfile>
  <div class="loading-wrapper">
    <mat-spinner diameter="25"></mat-spinner>
  </div>
</ng-template>
